import { Controller } from "@hotwired/stimulus"

// Drives the first-run getting-started hero. Every few seconds it pulls a fresh
// progress board (companies ticking off as their rosters import, first findings
// surfacing) and swaps it in WITHOUT a full-page reload, so the wait feels alive.
// Once the server marks the wave done — the fragment carries [data-onboarding-ready]
// — it does one full navigation to the now-populated dashboard. A hard timeout
// advances regardless, so a stalled import never traps the customer here.
export default class extends Controller {
  static targets = ["body"]
  static values = {
    url: String,
    dashboardUrl: { type: String, default: "/account" },
    interval: { type: Number, default: 3000 },
    timeout: { type: Number, default: 600000 },
  }

  connect() {
    this.deadline = Date.now() + this.timeoutValue
    // The server already rendered the initial board, so the first refresh waits
    // one interval rather than firing immediately.
    this.timer = setInterval(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async tick() {
    if (Date.now() > this.deadline) return this.advance()
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      if (!res.ok) return
      const html = await res.text()
      if (this.hasBodyTarget) this.bodyTarget.innerHTML = html
      if (this.element.querySelector("[data-onboarding-ready]")) this.advance()
    } catch (_e) {
      // transient network blip — keep polling until the deadline
    }
  }

  advance() {
    if (this.timer) clearInterval(this.timer)
    window.location.assign(this.dashboardUrlValue)
  }
}
